module.exports = __webpack_public_path__ + "img/footer_logo.d7c372d.png";